<template>
  <div
    v-if="room.visible == true"
    class="roomList"
    :class="{
      large: room.buttonSize == 'large',
    }"
  >
    <button
      class="room-buttom"
      @click="roomSelect(room)"
    >
      <img v-if="room.hasPassword" src="../assets/icons/lock2.svg"/>
      <p id="name">Enter {{ room.name }}</p>
      <p id="time">{{ room.time }}</p>
      <p id="date">{{ room.date }}</p>
      <div class="res-header" v-if="residencyTag != undefined">
        <div class="res-icon">⎆</div>
        <p class="small">Residency</p>
      </div>
      <div class="res-header" v-if="livestreamTag != undefined">
        <div class="res-icon">⎆</div>
        <p class="small">Livestream</p>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: ["room"],
  computed: {
    username() {
      return this.$store.state.username;
    },
    livestreamTag() {
      let found = this.$props.room.roomOptions.find(
        (element) => element.__component === "room-options.livestream"
      );
      return found;
    },
    residencyTag() {
      let found = this.$props.room.roomOptions.find(
        (element) => element.__component === "room-options.residency"
      );
      return found;
    },
  },
  methods: {
    roomSelect(room) {
      this.$router.push("/room/" + room.slug);
    }
  },
};
</script>

<style>
div.roomList {
  position: relative;
  max-width: 50%;
  height: 15vh;
  min-height: 100px;
  padding: 12px 10px 12px 10px;
  display: flex;
  flex-basis: 50%;
  flex-grow: 0;
  flex-shrink: 1;
  align-self: flex-start;
}

div.roomList.large {
  width: 100%;
  max-width: 100%;
  flex-grow: 2;
  flex-basis: 100%;
}

.roomList button {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  filter: var(--drop-shadow);
  background-color: var(--default-room-button-bg-color);
}

.roomList button:hover {
  background-color: var(--default-room-button-hover-bg-color);
}

.roomList button, .roomList label {
  font-size:16px;
  border: none;
  cursor: pointer;
  padding: 8px;
  /* border-radius:20px; */
}

.res-header {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 5px 10px 5px 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.res-icon {
  top: 0;
  font-size: 1.2em;
  margin-right: 0.15em;
}

.small {
  height: 1.2em;
}

#authentication {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
}

#authentication p {
  z-index: 1000;
  font-size: 16px;
  margin-block-start: 0px;
  margin-block-end: 0px;
}

#authentication button {
  width: initial;
  height: 35px;
  margin: 0 auto;
  filter: none;
}

p#time {
  position: absolute;
  top: 5px;
  right: 10px;
}

p#date {
  position: absolute;
  top: 5px;
  left: 10px;
}

p#name {
  font-weight: 400;
  font-size: var(--room-button-font-size);
}

.roomList button img {
  height:0.9em;
  margin:5px;
}
</style>